import { render } from "./MaterialsGuide.vue?vue&type=template&id=ff286bb2"
import script from "./MaterialsGuide.vue?vue&type=script&lang=js"
export * from "./MaterialsGuide.vue?vue&type=script&lang=js"

import "./MaterialsGuide.vue?vue&type=style&index=0&id=ff286bb2&lang=less"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__